import { atom, useAtom } from "jotai";
import { loadingState } from "../states/loadingState";
import { toastState } from "../states/toastState";
import { useTranslation } from "react-i18next";

const useCommonState = () => {
  const [isLoading, setIsLoading] = useAtom(loadingState);
  const setToastConfig = useAtom(toastState);
  const { t } = useTranslation();

  return { isLoading, setIsLoading, setToastConfig, t };
};

export default useCommonState;
